export default function CertificateIcon({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_377_38502)">
          <path
            d="M15.418 14.8648C16.2767 14.7388 16.8869 14.4949 17.3583 14.0235C18.3346 13.0473 18.3346 11.4758 18.3346 8.33317C18.3346 5.19047 18.3346 3.61913 17.3583 2.64281C16.3821 1.6665 14.8106 1.6665 11.668 1.6665H8.33464C5.19194 1.6665 3.62059 1.6665 2.64428 2.64281C1.66797 3.61913 1.66797 5.19047 1.66797 8.33317C1.66797 11.4758 1.66797 13.0473 2.64428 14.0235C3.31776 14.697 4.27439 14.9059 5.83464 14.9707"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M14.1654 5.8335H5.83203"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.0846 12.0833C12.0846 13.2339 11.1519 14.1667 10.0013 14.1667C8.85072 14.1667 7.91797 13.2339 7.91797 12.0833C7.91797 10.9327 8.85072 10 10.0013 10C11.1519 10 12.0846 10.9327 12.0846 12.0833Z"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            d="M7.91797 12.0835C7.91797 15.4717 9.35314 17.3923 10.0013 18.3335L11.2513 15.8335L12.7096 16.6668L14.168 17.5002C13.5557 16.9075 12.9228 15.0394 12.9228 15.0394"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_377_38502">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
